import script from "./PaymentCryptoIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentCryptoIndex.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentCryptoIndex.vue?vue&type=style&index=0&id=21072236&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21072236"]])

export default __exports__